// extracted by mini-css-extract-plugin
export default {"vbUiBtnDanger":"t9v_K__vbUiBtnDanger km0_Y__vbUiBtn"};